import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMobileSubNavQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
}>;


export type GetMobileSubNavQuery = { __typename?: 'Query', mobile_nav?: { __typename?: 'mobile_nav', id: string, spins_nav?: Array<{ __typename?: 'mobile_nav_spins', spins_id?: { __typename?: 'spins', id: string, status?: string | null, internal_name?: string | null, view_all_first_collection?: boolean | null, icon?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'spins_translations', slug: string, title: string } | null> | null, collections?: Array<{ __typename?: 'spins_Collections_1', id: string, Collections_id?: { __typename?: 'Collections', translations?: Array<{ __typename?: 'Collections_translations', slug?: string | null } | null> | null } | null } | null> | null } | null } | null> | null, bingo_nav?: Array<{ __typename?: 'mobile_nav_Bingo', Bingo_id?: { __typename?: 'Bingo', id: string, status?: string | null, internal_name?: string | null, view_all_first_collection?: boolean | null, icon?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'Bingo_translations', slug: string, title: string } | null> | null, collections?: Array<{ __typename?: 'Bingo_Collections_1', id: string, Collections_id?: { __typename?: 'Collections', translations?: Array<{ __typename?: 'Collections_translations', slug?: string | null } | null> | null } | null } | null> | null } | null } | null> | null } | null };


export const GetMobileSubNavDocument = gql`
    query getMobileSubNav($language: String!) {
  mobile_nav {
    id
    spins_nav {
      spins_id {
        id
        status
        internal_name
        icon {
          filename_disk
          width
          height
        }
        view_all_first_collection
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          slug
          title
        }
        collections(filter: {Collections_id: {status: {_eq: "published"}}}, limit: 1) {
          id
          Collections_id {
            translations(
              filter: {languages_language_code: {language_code: {_eq: $language}}}
            ) {
              slug
            }
          }
        }
      }
    }
    bingo_nav {
      Bingo_id {
        id
        status
        internal_name
        icon {
          filename_disk
          width
          height
        }
        view_all_first_collection
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          slug
          title
        }
        collections(filter: {Collections_id: {status: {_eq: "published"}}}, limit: 1) {
          id
          Collections_id {
            translations(
              filter: {languages_language_code: {language_code: {_eq: $language}}}
            ) {
              slug
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMobileSubNavQuery__
 *
 * To run a query within a React component, call `useGetMobileSubNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileSubNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileSubNavQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetMobileSubNavQuery(baseOptions: Apollo.QueryHookOptions<GetMobileSubNavQuery, GetMobileSubNavQueryVariables> & ({ variables: GetMobileSubNavQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>(GetMobileSubNavDocument, options);
      }
export function useGetMobileSubNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>(GetMobileSubNavDocument, options);
        }
export function useGetMobileSubNavSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>(GetMobileSubNavDocument, options);
        }
export type GetMobileSubNavQueryHookResult = ReturnType<typeof useGetMobileSubNavQuery>;
export type GetMobileSubNavLazyQueryHookResult = ReturnType<typeof useGetMobileSubNavLazyQuery>;
export type GetMobileSubNavSuspenseQueryHookResult = ReturnType<typeof useGetMobileSubNavSuspenseQuery>;
export type GetMobileSubNavQueryResult = Apollo.QueryResult<GetMobileSubNavQuery, GetMobileSubNavQueryVariables>;